import { memo, useCallback } from 'react';

import { useTrackClosedVersionsTray, useTrackOpenedVersionsTray } from '@air/analytics';
import { LayersIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { useVersionsPanelToggle } from '~/components/AssetModalV2/hooks/useVersionsPanelToggle';

export const AssetModalVersionsButton = memo(() => {
  const { isVersionsPanelOpen, toggleVersionsPanel } = useVersionsPanelToggle();
  const { trackOpenedVersionsTray } = useTrackOpenedVersionsTray();
  const { trackClosedVersionsTray } = useTrackClosedVersionsTray();

  const label = isVersionsPanelOpen ? 'Hide versions' : 'Show versions';

  const handleClick = useCallback(() => {
    if (isVersionsPanelOpen) {
      trackClosedVersionsTray();
    } else {
      trackOpenedVersionsTray();
    }

    toggleVersionsPanel();
  }, [isVersionsPanelOpen, toggleVersionsPanel, trackClosedVersionsTray, trackOpenedVersionsTray]);

  return (
    <Tooltip label={label}>
      <IconButton
        adsIcon
        icon={LayersIcon}
        label={label}
        appearance={isVersionsPanelOpen ? 'filled' : 'ghost'}
        color="gray"
        size="medium"
        data-testid="VERSIONS_BUTTON"
        onClick={handleClick}
      />
    </Tooltip>
  );
});

AssetModalVersionsButton.displayName = 'AssetModalVersionsButton';
